<app-basic-user-card
  [name]="name"
  [description]="description"
  [descriptionItems]="descriptionItems"
  [suffix]="suffix"
  [contentWidth]="contentWidth"
  [descriptionMaxWidth]="descriptionMaxWidth"
  [leftContentMargin]="leftContentMargin"
  [padding]="padding"
>
  <div start class="start">
    <ng-content select="[start]"></ng-content>

    @if (isTeam) {
      <app-roles-icon></app-roles-icon>
    } @else {
      @if (isAvatarEnabled) {
        <app-basic-celo-avatar
          size="36"
          [name]="name"
          [userId]="userId"
          [isIdentityVerified]="isIdentityVerified"
          [isWorkspaceVerified]="isWorkspaceVerified"
          [isProfessionVerified]="isProfessionVerified"
          [isExternal]="isExternal"
          [fetchImage]="fetchImage"
        ></app-basic-celo-avatar>
      }
    }
  </div>

  <ng-content end select="[end]"></ng-content>
</app-basic-user-card>
